import {IInsuranceContent} from "@/model/Content/InsuranceContent"

export interface IHasInsuranceContent {
    getInsuranceContent(): IInsuranceContent | null
    setInsuranceContent(content: IInsuranceContent): void
}

function hasInsuranceContent<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasInsuranceContent {
        private content: IInsuranceContent | null = null

        constructor(...args: any[]) {
            super(...args);
        }

        public getInsuranceContent(): IInsuranceContent | null {
            return this.content
        }
        public setInsuranceContent(content: IInsuranceContent): void {
            this.content = content
        }
    };
}

export default hasInsuranceContent